module.exports = __webpack_public_path__ + "assets/img/second-screenshot.7467dd0a.png";